import { render } from "./ReportComponent.vue?vue&type=template&id=8b1b4a7e"
import script from "./ReportComponent.vue?vue&type=script&lang=js"
export * from "./ReportComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__